import { faqs } from "@/constants/content";
import { Accordion, AccordionTab } from "primereact/accordion";
import React from "react";

const FAQs = () => {
  return (
    <Accordion activeIndex={0}>
      {faqs?.map((faq) => (
        <AccordionTab key={faq?.header} header={faq?.header}>
          <p className="m-0">{faq?.panel}</p>
        </AccordionTab>
      ))}
    </Accordion>
  );
};

export default FAQs;
